// extracted by mini-css-extract-plugin
export default {"page-header":"PageHeader_page-header__pGB9M","page-actions":"PageHeader_page-actions__h0kfC","btn":"PageHeader_btn__bQulp"};